import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import ImageSvg from "../ui/image-svg";

export const AboutSection = () => {
  return (
    <section id="sobre-nacionalgo" className=" py-10 md:py-24">
      <div className="container">
        <div className="grid md:grid-cols-2 gap-8">
          <div>
            <h2 className="mb-5 text-n-text-green text-3xl font-semibold md:mb-6 md:text-4xl lg:text-5xl">
              A Nacional GO é pioneira em oferecer uma experiência digital
              completa no transporte de veículos
            </h2>
            <p className="md:text-lg text-n-text-neutral">
              Nossa plataforma conecta você a transportadoras confiáveis,
              garantindo que seu veículo chegue ao destino com segurança. Com um
              sistema otimizado, você acompanha cada etapa do transporte em
              tempo real.
            </p>

            <div className="mt-6 flex flex-wrap items-center gap-4 md:mt-8">
              <Link to="/fazer-cotacao">
                <Button id="btn-fazer-cotacao">
                  Contrate agora
                  <ArrowRight className="ml-2 " />
                </Button>
              </Link>
            </div>
          </div>

          <div className="flex items-center justify-center px-10">
            <ImageSvg
              src="concept-company.svg"
              alt="A Nacional GO é pioneira em oferecer uma experiência digital completa no transporte de veículos"
              className="max-w-full"
            />
          </div>
        </div>
      </div>
    </section>
  );
};
